import React, { useCallback, useState } from 'react'
import {
  BooleanColumn,
  BsrsGrid,
  Column,
  commandColumnProps,
  LookupNameColumn
} from '@/components/BsrsGrid'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import { format } from '@/utils/StringUtilities'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import moment from 'moment'
import { openAlertDialog } from '@/utils/dialogHelpers'

function RtgsReportsGrid () {
  const { localize, locale } = useLocalization()
  const detailUrlFormat = '/Rtgsreports/{0}'
  const [lastReloadedAt, setLastReloadedAt] = useState(moment())

  const onDelete = useCallback(item => {
    context.api.rtgsService.deleteRtgsReportItem(item.id)
      .then(() => setTimeout(() => setLastReloadedAt(moment()), 300))
      .catch((response) => {
        const message = response && response.response && response.response.data && response.response.data.error
          ? response.response.data.error.message
          : localize('Common.Exception')
        openAlertDialog({ title: 'Common.Exception', text: message })
      })
  }, [localize])

  const isGranted = usePermissionChecker()
  const canManage = isGranted('Scopes.Rtgsreports.Edit')

  return <BsrsGrid persistenceId={'Rtgsreports'} defaultSort={[{ field: 'financialYear', dir: 'desc' }]}
    dataSource={context.api.rtgsService.getTableData} lastReloadedAt={lastReloadedAt}>
    {LookupNameColumn({ locale, field: 'company', title: localize('Institutions.CompanyName'), editable: false })}
    <Column field='financialYear' title={localize('Common.FinancialYear')} editable={false} filter='numeric' />
    {BooleanColumn({ field: 'q1Submission', title: localize('Reporting.Q1'), editable: false })}
    {BooleanColumn({ field: 'q2Submission', title: localize('Reporting.Q2'), editable: false })}
    {BooleanColumn({ field: 'q3Submission', title: localize('Reporting.Q3'), editable: false })}
    {BooleanColumn({ field: 'q4Submission', title: localize('Reporting.Q4'), editable: false })}
    {BooleanColumn({ field: 'endOfYearFsSubmission', title: localize('Reporting.EndOfYearFinancialStatement'), editable: false })}
    <Column {...commandColumnProps({
      detailUrl: x => format(detailUrlFormat, x.id),
      deleteAction: onDelete,
      deleteDisabled: !canManage
    })} title=' ' width={80} />
  </BsrsGrid>
}

export default RtgsReportsGrid



// WEBPACK FOOTER //
// ./src/components/reporting/rtgsReportsGrid.js